export const PACKAGE_NAME = '@project44/material-ui-deprecated';
